/**
 * Складывает две ISO 8601 длительности (PT1H30M15S) и возвращает сумму в том же формате.
 * @param {string} time1 - Первая длительность в формате ISO 8601.
 * @param {string} time2 - Вторая длительность в формате ISO 8601.
 * @returns {string} Сумма длительностей в формате ISO 8601.
 */
function addTimeIntervalISO8601(time1, time2) {
  if (time1 && !time2) {
    return time1;
  }
  if (!time1 && time2) {
    return time2;
  }

  const regex = /PT(-?\d+H)?(-?\d+M)?(-?\d+(?:\.\d+)?S)?/;
  const [, hours1 = '0H', minutes1 = '0M', seconds1 = '0S'] = regex.exec(time1);
  const [, hours2 = '0H', minutes2 = '0M', seconds2 = '0S'] = regex.exec(time2);

  const totalHours = parseInt(hours1, 10) + parseInt(hours2, 10);
  const totalMinutes = parseInt(minutes1, 10) + parseInt(minutes2, 10);
  const totalSeconds = parseFloat(seconds1.replace('S', '')) + parseFloat(seconds2.replace('S', ''));

  let formattedResult = 'PT';

  if (totalHours !== 0) {
    formattedResult += `${totalHours}H`;
  }

  if (totalMinutes !== 0) {
    formattedResult += `${totalMinutes}M`;
  }

  if (totalSeconds !== 0) {
    formattedResult += `${totalSeconds.toFixed(4)}S`;
  }

  return formattedResult;
}

export default addTimeIntervalISO8601;
